"use client";

import type { PublicationType } from "agir-types";
import type { ReactNode } from "react";

import { FastCommentsCommentCount } from "fastcomments-nextjs";

import { useConsent } from "@/src/infrastructure/cookieconsent/consent";
import {
  fastCommentsConfig,
  fastCommentsCookie,
  fastCommentsUrlId,
} from "@/src/infrastructure/fastcomments/fastComments";

export interface CommentCountBadgeProps {
  readonly id: string;
  readonly type: PublicationType;
}

export function CommentCountBadge({
  id,
  type,
}: CommentCountBadgeProps): ReactNode {
  const consented = useConsent(fastCommentsCookie);

  if (!consented) {
    return null;
  }

  return (
    <span aria-hidden className="inline-flex items-center gap-1">
      <span>💬</span>
      <span className="font-bold-antialiased inline-block min-w-[3ch] tabular-nums">
        <FastCommentsCommentCount
          numberOnly
          region="eu"
          tenantId={fastCommentsConfig.tenantId}
          urlId={fastCommentsUrlId(type, id)}
        />
      </span>
    </span>
  );
}
